module.exports = __webpack_public_path__ + "img/12.2c0b2d9f.jpg";